/** @format */

import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import Headers from "../components/Headers";

import OtpVerificationForm from "../components/OtpVerification";
//import { setCustomerInfo } from '../features/authSlice'; // À adapter selon ton slice
import { useCategories } from "../utils/Categories";

const VerificationOtp = () => {
  const { newCustomerId } = useSelector((state) => state.auth);
  const { categories, clientLocation } = useCategories();

  return (
    <div>
      <Headers categories={categories} clientLocation={clientLocation} />
      <div className='bg-slate-200 mt-4 p-10'>
        <OtpVerificationForm customerId={newCustomerId} />
      </div>
      <Footer />
    </div>
  );
};

export default VerificationOtp;
